import React from "react";

// Rising-sun / concentric arcs motif. Stroke-only, decorative.
export const SunArcs = ({
  className = "",
  color = "#C9A227",
  rings = 5,
  spin = false,
  opacity = 0.4,
}) => {
  const base = 34;
  const step = 30;
  return (
    <svg
      viewBox="0 0 400 220"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ opacity }}
    >
      <g className={spin ? "alba-spin-slow" : ""} style={{ transformOrigin: "200px 200px" }}>
        {Array.from({ length: rings }).map((_, i) => (
          <path
            key={i}
            d={`M ${200 - (base + i * step)} 200 A ${base + i * step} ${base + i * step} 0 0 1 ${200 + (base + i * step)} 200`}
            stroke={color}
            strokeWidth={1.4}
            strokeLinecap="round"
          />
        ))}
      </g>
      <line x1="20" y1="200" x2="380" y2="200" stroke={color} strokeWidth={1.4} strokeLinecap="round" />
    </svg>
  );
};

// Full rising sun with rays, used as favicon-like accent / separators.
export const SunRays = ({ className = "", color = "#C9A227", opacity = 0.5 }) => (
  <svg viewBox="0 0 240 130" fill="none" aria-hidden="true" className={className} style={{ opacity }}>
    <g stroke={color} strokeWidth="1.5" strokeLinecap="round">
      <path d="M40 120h160" />
      <path d="M70 120a50 50 0 0 1 100 0" />
      <path d="M90 120a30 30 0 0 1 60 0" />
      {Array.from({ length: 9 }).map((_, i) => {
        const a = Math.PI + (i * Math.PI) / 8;
        const x1 = 120 + Math.cos(a) * 68;
        const y1 = 120 + Math.sin(a) * 68;
        const x2 = 120 + Math.cos(a) * 84;
        const y2 = 120 + Math.sin(a) * 84;
        return <path key={i} d={`M${x1} ${y1}L${x2} ${y2}`} />;
      })}
    </g>
  </svg>
);

// Thin section divider carrying the motif.
export const ArcDivider = ({ color = "#C9A227" }) => (
  <div className="relative w-full flex justify-center overflow-hidden" data-testid="arc-divider">
    <SunArcs className="w-[520px] max-w-[90vw] -mb-[1px]" color={color} rings={4} opacity={0.35} />
  </div>
);
